<div class="global-var-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="dialogRef.close()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <mat-dialog-content class="dialog-content">
    <div class="dialog-content-wrapper">
      <div class="global-var-list-wrapper mt-2 mb-2">
        @for (item of varList(); track item.id) {
          <div class="variable-item">
            <div class="variable-content" #variableContent>
              <strong
                [matTooltip]="item.value"
                [matTooltipShowDelay]="500"
                matTooltipPosition="above"
                >{{ item.name }} =
                {{
                  generalHelpers.trueTypeOf(item.value) === "array" ||
                  generalHelpers.trueTypeOf(item.value) === "object"
                    ? (item.value | json)
                    : item.value
                }}</strong
              >
            </div>
            <div class="variable-actions">
              <button mat-icon-button (click)="edit(item)" matTooltip="Edit">
                <mat-icon>edit</mat-icon>
              </button>
              @if (hasWritePermission() && isMainVersion) {
                <button
                  mat-icon-button
                  (click)="delete(item)"
                  matTooltip="Delete"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>

      <form
        [formGroup]="globalVarForm"
        (ngSubmit)="
          processGlobalVarForm(globalVarForm.value, globalVarForm.valid, $event)
        "
        class="variable-form"
      >
        <div
          fxLayout="column"
          fxLayoutAlign="start center"
          fxLayoutGap="16px"
          class="mb-3"
        >
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Variable Name</mat-label>
            <input
              matInput
              formControlName="name"
              placeholder="Variable name"
            />
            <mat-hint
              >Must start with a letter, $, or _. Can contain letters, numbers,
              $ and _</mat-hint
            >
            @if (globalVarForm.get("name")?.errors?.["required"]) {
              <mat-error> Name is required </mat-error>
            }
            @if (globalVarForm.get("name")?.errors?.["pattern"]) {
              <mat-error> Invalid variable name format </mat-error>
            }
            @if (globalVarForm.get("name")?.errors?.["notUnique"]) {
              <mat-error> Name must be unique </mat-error>
            }
          </mat-form-field>

          <app-code-editor
            [content]="content()"
            (updateContent)="updateContent($event)"
            (startEdit)="setFormTouched()"
            mode="json"
            class="w-100"
          >
          </app-code-editor>

          @if (showEmptyValueError()) {
            <div class="error-message">Value cannot be empty</div>
          }
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <!-- Modal Actions — kept outside the scrolling dialog content so the
       Close/Update footer stays visible regardless of editor height (SCRUM-689). -->
  <div class="modal-actions">
    <button class="cancel-button" (click)="dialogRef.close()">Close</button>
    <button
      class="confirm-button"
      (click)="
        processGlobalVarForm(
          globalVarForm.value,
          globalVarForm.valid,
          $event
        )
      "
      [disabled]="confirmButtonDisabled()"
    >
      {{ getActionButtonText() }}
    </button>
  </div>
</div>
